import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { routes } from "../../routes";
import {ReactComponent as  Swords } from "../../assets/icons/swords.svg";
import battle1 from "../../assets/images/Battles/battle1.png";
import { toast } from "react-toastify";
import {
  battleCancel,
  joinBattle,
} from "../../api/modules/b2droppie.class";
import { toggleOnboard } from "../../redux/slices/onBoardingSlice";
import BackdropLoader from "../BackdropLoader/BackdropLoader";
import SpinBackground from "../../assets/images/spinBackground.png";
import Crazy from "../../assets/icons/crazy.svg";
import {ReactComponent as CrazyZap} from "../../assets/icons/crazy_zap.svg";
const BattleWait = ({ battle, setJoinPrivate, shareLink }) => {
  console.log(battle);
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);
  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);
  const user = useSelector((state) => state?.auth?.user);
  const balance = useSelector((state) => state?.account?.balance);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slugId } = useParams();
  const [topUp, setTopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  // Mobile detection
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 641);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 641);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Swipe-to-close state (mirrors Login modal)
  const [dragY, setDragY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const startY = useRef(0);

  // Reset drag when modal opens
  useEffect(() => {
    if (showCancelModal) {
      setDragY(0);
      setIsDragging(false);
    }
  }, [showCancelModal]);

  // Touch handlers
  const handleTouchStart = (e) => {
    if (!isMobile) return;
    startY.current = e.touches[0].clientY;
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isMobile || !isDragging) return;
    const diff = e.touches[0].clientY - startY.current;
    if (diff > 0) setDragY(diff);
  };

  const handleTouchEnd = () => {
    if (!isMobile) return;
    setIsDragging(false);
    if (dragY > 150) setShowCancelModal(false);
    setDragY(0);
  };

  // Backdrop opacity fades as user drags
  const backdropOpacity = isMobile ? Math.max(0, 1 - dragY / 300) : 1;

  // Decrypt slugId to get battle ID
  const decryptData = () => {
    try {
      const decodedData = parseInt(window.atob(slugId));
      return decodedData;
    } catch (error) {
      console.error("Decryption error:", error);
      return null;
    }
  };

  // Handle battle cancellation (only for creator)
  const handleCancel = () => {
    const decryptedData = JSON.stringify(decryptData());

    battleCancel(decryptedData)
      .then((response) => {
        if (response?.data?.message == "Battle cancelled") {
          navigate(routes?.BATTLES);
        }
      })
      .catch((error) => {
        console.error("❌ Error cancelling battle:", error);
      });
  };

  const handleJoin = () => {
    const decryptedData = decryptData();

    if (!isLoggedIn) {
      dispatch(toggleOnboard({ login: true }));
      return;
    }

    if (balance < parseFloat(battle?.stake_amount)) {
      toast.warning("Insufficient balance", {
        autoClose: 3000,
        position: "top-center",
      });
      setTopup(true);
      return;
    }

    setIsLoading(true);

    joinBattle(decryptedData)
      .then((response) => {
        if (response?.data?.success && response?.data?.message === "Joined") {
          setJoinPrivate(true);
          localStorage.setItem(
            `battle_waiting_${decryptData()}`,
            JSON.stringify({ waiting: true, battleId: decryptData(), timestamp: Date.now() })
          );
        }
      })
      .catch((e) => {
        console.error("❌ Error joining battle:", e);
        console.error("Error details:", e.response?.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Check user roles
  const isCreator = user?.id === battle?.creator_id;
  const isBattleWaiting = battle?.status === "waiting";

  return (
    <>
      {/* Battle Details */}
      <div
        className={
          isDarkMode
            ? "container end-battle-detail-dark battle-wait-spacing"
            : "end-battle-detail battle-wait-spacing"
        }
        style={{
          backgroundImage: battle?.mode =="crazy" ? `url(${Crazy}), url(${SpinBackground})`:`url(${SpinBackground})`,
          backgroundPosition: "center, center",
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundSize: "contain, cover",
        }}
      >
        {/* Heading */}
        <div>
          {isCreator ? (
            <h1 className="battle-ended-text">Waiting For Opponent...</h1>
          ) : isBattleWaiting ? (
            <h1 className="battle-ended-text">Join This Battle</h1>
          ) : null}
        </div>

        {/* Players Row */}
        <div className="playersRowWait">
          {/* Creator Avatar */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div className="avatar_div">
              <img
                src={
                  battle?.players
                    ? `${battle?.players?.[0]?.user?.userdetails?.avatar}`
                    : battle1
                }
                alt="Creator"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>

          {/* Swords Icon */}
          {battle?.mode =="crazy"?  <CrazyZap  style={{ width: "40px", height: "40px" }}/>: <Swords
            className="sword-icon-color"
            style={{ width: "40px", height: "40px" }}
          />
          }
          {/* Opponent Placeholder */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div class="mystery-user">
                <span>?</span>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        {isCreator ? (
          // Creator sees Cancel and Share buttons
          <div className="battle-wait-btn-sp"
          >
            <button
              className="cancel-battle-btn"
              onClick={() => setShowCancelModal(true)}
              onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
            >
              Cancel Battle
            </button>

            {battle?.private && (
              <div style={{ position: "relative" }}>
                {/* Tooltip */}
                {copied && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "100%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      marginBottom: "8px",
                      background: "#2D2A33",
                      color: "#fff",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Space Grotesk",
                      whiteSpace: "nowrap",
                      boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
                      zIndex: 1000,
                    }}
                  >
                    Link copied!
                    {/* Arrow */}
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: 0,
                        height: 0,
                        borderLeft: "6px solid transparent",
                        borderRight: "6px solid transparent",
                        borderTop: "6px solid #2D2A33",
                      }}
                    />
                  </div>
                )}

                <button
                className="battle-wait-btn-copy"
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(window.location.href);
                      setCopied(true);
                      setTimeout(() => setCopied(false), 2000);
                    } catch (err) {
                      console.error("Failed to copy: ", err);
                    }
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                >
                  Copy Link
                </button>
              </div>
            )}
          </div>
        ) : (
          // Non-creator
          <div
            style={{
              display: "flex",
              gap: "16px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {isBattleWaiting ? (
              isLoading ? (
                <BackdropLoader show={true} />
              ) : (
                <button
                  onClick={handleJoin}
                  disabled={isLoading}
                  style={{
                    background: "#684199",
                    border: "none",
                    borderRadius: "25px",
                    padding: "12px 40px",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: 600,
                    fontFamily: "Space Grotesk",
                    cursor: isLoading ? "not-allowed" : "pointer",
                    transition: "0.2s",
                    opacity: isLoading ? 0.6 : 1,
                  }}
                  onMouseEnter={(e) =>
                    !isLoading && (e.target.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                >
                  {isLoading
                    ? "Joining..."
                    : `Join Battle (${battle?.stake_amount} USD)`}
                </button>
              )
            ) : (
              <BackdropLoader show={true} />
            )}
          </div>
        )}
      </div>

      {/* ─── Cancel Modal ─────────────────────────────────────────── */}
      {showCancelModal && (
        <div
          className={`battle-cancel-model ${isMobile ? "battle-cancel-model-mobile" : ""}`}
          style={isMobile ? { "--backdrop-opacity": backdropOpacity } : {}}
          onClick={(e) => {
            // Close on backdrop click (desktop)
            if (e.target === e.currentTarget && !isMobile)
              setShowCancelModal(false);
          }}
        >
          <div
            className={`battle-cancel-model-box ${
              isDarkMode
                ? "battle-cancel-model-box-dark"
                : "battle-cancel-model-box-light"
            } ${isMobile ? "battle-cancel-model-box-sheet" : ""}`}
            style={
              isMobile
                ? {
                    transform: `translateY(${dragY}px)`,
                    transition: isDragging ? "none" : "transform 0.3s ease-out",
                  }
                : {}
            }
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {/* Swipe handle — mobile only */}
            {isMobile && (
              <div className="battle-cancel-swipe-handle-container">
                <div className="battle-cancel-swipe-handle" />
              </div>
            )}

            {/* Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "24px",
              }}
            >
              <span
                className={`${
                  isDarkMode
                    ? "battle-cancel-model-title-dark"
                    : "battle-cancel-model-title-light"
                }`}
                style={{ fontSize: "22px", fontWeight: 700 }}
              >
                Cancel Battle?
                <span>
                  <p
                    className={`battle-cancel-model-text ${
                      isDarkMode
                        ? "battle-cancel-model-text-dark"
                        : "battle-cancel-model-text-light"
                    }`}
                  >
                    Are you sure you want to cancel this battle?
                  </p>
                </span>
              </span>
            </div>

            <div
              className="mb-3"
              style={{
                borderBottom: isDarkMode
                  ? "1px solid #27242B"
                  : "1px solid #ECECEC",
                marginLeft: "-40px",
                marginRight: "-40px",
              }}
            />
            {/* Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "16px",
              }}
            >
              {/* No button */}
              <button
                onClick={() => setShowCancelModal(false)}
                style={{
                  flex: 1,
                  background: "#262626",
                  border: "none",
                  borderTop: "1px solid #4D4D4D",
                  borderRadius: "8px",
                  padding: "14px 0",
                  color: "#A6A6A6",
                  fontWeight: 600,
                  fontSize: "15px",
                  cursor: "pointer",
                  transition: "0.2s",
                }}
              >
                No, Keep It
              </button>

              {/* Yes button */}
              <button
                onClick={() => {
                  setShowCancelModal(false);
                  handleCancel();
                }}
                className={`battle-cancel-button ${
                  isDarkMode
                    ? "battle-cancel-button-dark"
                    : "battle-cancel-button-light"
                }`}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                Yes, Cancel
              </button>
            </div>

            {/* Bottom handle bar — mobile only */}
            {isMobile && (
              <div className="battle-cancel-swipe-handle-container-bottom">
                <div className="battle-cancel-swipe-handle-bottom" />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BattleWait;